import React, { useState, useCallback } from 'react';
import { ISaveConfirmDialogResult } from 'types/dialogs';
import SaveConfirmDialog from './SaveConfirmDialog';

const useSaveConfirmDialog = () => {
	const [saveConfirmDialogJsx, setSaveConfirmDialogJsx] =
		useState<React.JSX.Element | null>(null);

	const openSaveConfirmDialog = useCallback(
		() =>
			new Promise<ISaveConfirmDialogResult>((resolve) => {
				setSaveConfirmDialogJsx(
					<SaveConfirmDialog
						onClose={(res) => {
							setSaveConfirmDialogJsx(null);
							resolve(res);
						}}
					/>
				);
			}),
		[]
	);

	return { saveConfirmDialogJsx, openSaveConfirmDialog };
};

export default useSaveConfirmDialog;
